module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10254.887003f0.jpg";